import { render, staticRenderFns } from "./SyncAlerts.vue?vue&type=template&id=6a966e7f"
import script from "./SyncAlerts.vue?vue&type=script&lang=js"
export * from "./SyncAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports